import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '../../utils/cn';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  label: string;
};

/**
 * Icon-only control with required accessible label.
 * Five interaction states match Button (hover / active / focus-visible / disabled).
 */
export function IconButton({ children, label, className, type = 'button', ...rest }: Props) {
  return (
    <button
      type={type}
      aria-label={label}
      className={cn(
        // Default + hover/disabled on the base; active + focus-visible shared with Button.
        'inline-flex items-center justify-center rounded-full p-2 text-[var(--muted)] hover:bg-[var(--muted-surface)] hover:text-[var(--foreground)] active:opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--accent)] disabled:opacity-40',
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
}
